import { render, staticRenderFns } from "./BreakoutRoom.vue?vue&type=template&id=da8fa608&"
import script from "./BreakoutRoom.vue?vue&type=script&lang=js&"
export * from "./BreakoutRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports